module.exports = __webpack_public_path__ + "static/img/1.69ce3b8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/1.jpg
// module id = 6KWl
// module chunks = 1